<template>
  <router-view />
</template>

<script>
export default {
  created() {
    // Rota única antiga (dashboard/user/list-bet)
    if (this.$route.name === "Apostas") {
      this.$router.push({ name: "SportBets" });
    }
  },
};
</script>
